import WarningIcon from '@atlaskit/icon/core/warning';
import * as React from 'react';

export function SvgAlertTriangle() {
  return <WarningIcon label="" testId="ads-refreshed-icon" />;
}
